<app-menu>
  <div class="ops-shell min-h-[calc(100vh-64px)]" [attr.data-theme]="themeMode">
    <div class="mx-auto flex min-h-[calc(100vh-64px)] max-w-[1760px] flex-col gap-4 px-4 py-4 sm:px-5 lg:px-6">
      <section class="ops-panel rounded-2xl">
        <div class="flex flex-col gap-4 border-b border-slate-200/80 px-4 py-4 sm:px-5 lg:flex-row lg:items-start lg:justify-between lg:px-6">
          <div class="min-w-0">
            <div class="flex flex-wrap items-center gap-2">
              <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#0f766e] text-white shadow-sm">
                <i class="fa-solid fa-chart-line text-sm"></i>
              </span>
              <h1 class="m-0 text-2xl font-black tracking-normal text-slate-950 sm:text-3xl">Lading Operations</h1>
              <span class="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-bold uppercase text-slate-500">
                {{ data?.meta?.dashboard_view || filters.dashboard_view }}
              </span>
            </div>
            <div class="mt-2 flex flex-wrap gap-2 text-xs font-semibold text-slate-500">
              <span class="inline-flex items-center gap-1.5">
                <i class="fa-regular fa-clock"></i>
                {{ asOfLabel }}
              </span>
              <span class="inline-flex items-center gap-1.5">
                <i class="fa-regular fa-calendar"></i>
                {{ filterWindowLabel }}
              </span>
              <span class="inline-flex items-center gap-1.5">
                <i class="fa-solid fa-globe"></i>
                {{ data?.meta?.timezone || filters.timezone }}
              </span>
            </div>
          </div>

          <div class="flex flex-wrap gap-2">
            <button type="button" class="ops-button ops-button-icon" (click)="toggleTheme()" [attr.aria-label]="'Switch to ' + (themeMode === 'dark' ? 'light' : 'dark') + ' theme'">
              <i class="fa-solid text-sm" [ngClass]="themeIcon"></i>
              {{ themeLabel }}
            </button>
            <button type="button" class="ops-button" (click)="resetFilters()" [disabled]="loading">
              <i class="fa-solid fa-rotate-left text-sm"></i>
              Reset
            </button>
            <button type="button" class="ops-button ops-button-primary" (click)="refreshDashboard()" [disabled]="loading">
              <i class="fa-solid fa-rotate text-sm" [class.fa-spin]="loading"></i>
              Refresh
            </button>
          </div>
        </div>

        <div class="ops-filter-grid px-4 py-4 xl:px-6">
          <label class="ops-field ops-field-view">
            <span class="ops-label">View</span>
            <ng-select
              class="ops-ng-select"
              [items]="dashboardViews"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [(ngModel)]="filters.dashboard_view"
            ></ng-select>
          </label>

          <label class="ops-field ops-field-basis">
            <span class="ops-label">Date Basis</span>
            <ng-select
              class="ops-ng-select"
              [items]="dateBasisOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [(ngModel)]="filters.date_basis"
            ></ng-select>
          </label>

          <label class="ops-field ops-field-date">
            <span class="ops-label">Start</span>
            <input class="ops-control" type="date" [(ngModel)]="filters.date_start">
          </label>

          <label class="ops-field ops-field-date">
            <span class="ops-label">End</span>
            <input class="ops-control" type="date" [(ngModel)]="filters.date_end">
          </label>

          <label class="ops-field ops-field-status">
            <span class="ops-label">Status</span>
            <ng-select
              class="ops-ng-select"
              [items]="statusFilterOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="true"
              [(ngModel)]="filters.lading_status"
            ></ng-select>
          </label>

          <label class="ops-field ops-field-stale">
            <span class="ops-label">Stale Hours</span>
            <input class="ops-control" type="number" min="1" max="720" [(ngModel)]="filters.stale_hours">
          </label>

          <label class="ops-field ops-field-rows">
            <span class="ops-label">Rows</span>
            <ng-select
              class="ops-ng-select"
              [items]="rowLimitOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [(ngModel)]="filters.detail_limit"
            ></ng-select>
          </label>

          <div class="ops-field ops-field-flags">
            <span class="ops-label">Scope</span>
            <div class="ops-scope-grid">
              <button type="button" class="ops-check" [class.is-active]="filters.active_only" (click)="filters.active_only = !filters.active_only">
                <i class="fa-solid fa-circle-check"></i>
                Active
              </button>
              <button type="button" class="ops-check" [class.is-active]="filters.include_cancelled" (click)="filters.include_cancelled = !filters.include_cancelled">
                <i class="fa-solid fa-ban"></i>
                Voided
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="activeContactFilter" class="flex flex-wrap items-center gap-2 border-t border-slate-200/80 px-4 py-3 text-sm xl:px-6">
          <span class="font-bold text-slate-500">Filtered by</span>
          <span class="inline-flex max-w-full items-center gap-2 rounded-full border border-teal-200 bg-teal-50 px-3 py-1 text-xs font-black uppercase text-teal-800">
            {{ activeContactFilter.name }}
          </span>
          <button type="button" class="rounded-full px-3 py-1 text-xs font-black text-slate-500 transition hover:bg-slate-100 hover:text-slate-900" (click)="clearContactFilter()">
            Clear
          </button>
        </div>
      </section>

      <div *ngIf="warnings.length" class="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-semibold text-amber-900 shadow-sm">
        <div class="flex items-start gap-2" *ngFor="let warning of warnings">
          <i class="fa-solid fa-circle-exclamation mt-0.5 text-amber-600"></i>
          <span>{{ warning }}</span>
        </div>
      </div>

      <div *ngIf="errorMessage" class="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-semibold text-rose-800 shadow-sm">
        <div class="flex items-start justify-between gap-3">
          <span class="min-w-0">{{ errorMessage }}</span>
          <button type="button" class="rounded-full px-2 py-0.5 text-rose-700 hover:bg-rose-100" (click)="errorMessage = ''">Close</button>
        </div>
      </div>

      <div *ngIf="loading" class="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-500 shadow-sm">
        <span class="ops-spinner"></span>
        <span>Loading operations dashboard...</span>
      </div>

      <section class="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
        <article *ngFor="let card of kpiCards; trackBy: trackByKpi" class="ops-kpi rounded-2xl border bg-white p-4 shadow-sm" [ngClass]="kpiToneClasses(card.tone)">
          <div class="flex items-start justify-between gap-3">
            <div class="min-w-0">
              <p class="m-0 text-[11px] font-black uppercase tracking-[0.16em] opacity-75">{{ card.label }}</p>
              <p class="m-0 mt-2 text-3xl font-black leading-none text-slate-950">{{ card.value | number }}</p>
            </div>
            <span class="inline-flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-white/80 shadow-sm ring-1 ring-black/5">
              <i class="fa-solid text-base" [ngClass]="card.icon"></i>
            </span>
          </div>
          <div class="mt-4 flex min-w-0 items-center justify-between gap-2 text-xs font-bold">
            <span class="truncate opacity-75">{{ card.caption }}</span>
            <span class="truncate rounded-full bg-white/80 px-2 py-1 text-slate-600 shadow-sm ring-1 ring-black/5">{{ card.detail }}</span>
          </div>
        </article>
      </section>

      <section class="grid min-h-0 gap-4 xl:grid-cols-[minmax(0,0.95fr)_minmax(0,1.45fr)]">
        <div class="ops-panel rounded-2xl p-4 lg:p-5">
          <div class="flex items-center justify-between gap-3">
            <div>
              <h2 class="m-0 text-lg font-black text-slate-950">Status Mix</h2>
              <p class="m-0 mt-1 text-xs font-semibold text-slate-500">{{ statusTotal | number }} orders in the current result set</p>
            </div>
            <span class="rounded-full bg-slate-100 px-3 py-1 text-xs font-black text-slate-600">{{ statusCounts.length }} statuses</span>
          </div>

          <div class="mt-5 space-y-3">
            <div *ngFor="let status of statusCounts; trackBy: trackByStatus" class="group">
              <div class="mb-1 flex items-center justify-between gap-3 text-xs font-black">
                <span class="min-w-0 truncate text-slate-700">{{ status.lading_status }}</span>
                <span class="text-slate-500">{{ status.count | number }}</span>
              </div>
              <div class="h-2.5 overflow-hidden rounded-full bg-slate-100">
                <div class="h-full rounded-full bg-[#0f766e] transition-all" [style.width.%]="percentOf(status.count, maxStatusCount)"></div>
              </div>
            </div>

            <div *ngIf="!statusCounts.length && !loading" class="rounded-xl border border-dashed border-slate-300 px-4 py-8 text-center text-sm font-bold text-slate-500">
              No status data for these filters.
            </div>
          </div>
        </div>

        <div class="ops-panel flex min-h-[520px] flex-col rounded-2xl p-4 lg:p-5">
          <div class="flex flex-col gap-3 border-b border-slate-200 pb-4 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h2 class="m-0 text-lg font-black text-slate-950">Attention Queue</h2>
              <p class="m-0 mt-1 text-xs font-semibold text-slate-500">{{ activeQueueCount | number }} {{ getQueueLabel(activeQueue) | lowercase }} orders</p>
            </div>
            <div class="flex flex-wrap gap-2">
              <button
                type="button"
                *ngFor="let tab of queueTabs"
                class="ops-tab"
                [class.is-active]="activeQueue === tab.key"
                (click)="selectQueue(tab.key)"
              >
                <i class="fa-solid" [ngClass]="tab.icon"></i>
                <span>{{ tab.label }}</span>
                <strong>{{ getQueueCount(tab.key) | number }}</strong>
              </button>
            </div>
          </div>

          <div class="hidden min-h-0 flex-1 overflow-auto lg:block">
            <table class="ops-table min-w-full">
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Status</th>
                  <th>Appointment</th>
                  <th>Activity</th>
                  <th>Customer / Carrier</th>
                  <th>Route</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of activeRows; trackBy: trackByQueue">
                  <td>
                    <div class="font-black text-slate-950">{{ rowReference(row) }}</div>
                    <div class="text-xs font-semibold text-slate-500">{{ row.trip_number || row.pro_bill || row.lading_number || 'No trip' }}</div>
                  </td>
                  <td>
                    <span class="inline-flex max-w-[190px] items-center rounded-full px-2.5 py-1 text-xs font-black ring-1" [ngClass]="statusTone(row.lading_status)">
                      <span class="truncate">{{ row.lading_status || row.latest_status || 'Unknown' }}</span>
                    </span>
                  </td>
                  <td>
                    <div class="font-bold text-slate-700">{{ formatDateTime(row.appointment_end_local || row.appointment_end || row.appointment_date) }}</div>
                    <div class="text-xs font-semibold text-slate-500">{{ formatDateOnly(row.load_start) }}</div>
                  </td>
                  <td>
                    <div class="font-bold text-slate-700">{{ timeAgo(row.status_activity_at) }}</div>
                    <div class="text-xs font-semibold text-slate-500">{{ formatDateTime(row.status_activity_at) }}</div>
                  </td>
                  <td>
                    <div class="max-w-[260px] truncate font-black text-slate-800">{{ row.customer_name || 'No customer' }}</div>
                    <div class="max-w-[260px] truncate text-xs font-semibold text-slate-500">{{ row.carrier_name || 'No carrier' }}</div>
                  </td>
                  <td>
                    <div class="max-w-[260px] truncate font-bold text-slate-700">{{ rowRoute(row) }}</div>
                    <div class="mt-1 flex flex-wrap gap-1">
                      <span *ngIf="row.hot" class="ops-chip bg-rose-50 text-rose-700 ring-rose-200">Hot</span>
                      <span *ngIf="row.expedited" class="ops-chip bg-amber-50 text-amber-800 ring-amber-200">Expedite</span>
                      <span *ngIf="row.drop_trailer" class="ops-chip bg-teal-50 text-teal-700 ring-teal-200">Drop</span>
                    </div>
                  </td>
                  <td class="text-right">
                    <button type="button" class="ops-icon-button" (click)="openWorkOrder(row)" title="Open work order">
                      <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="grid gap-3 pt-4 lg:hidden">
            <article *ngFor="let row of activeRows; trackBy: trackByQueue" class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <div class="flex items-start justify-between gap-3">
                <div class="min-w-0">
                  <h3 class="m-0 truncate text-base font-black text-slate-950">{{ rowReference(row) }}</h3>
                  <p class="m-0 mt-1 truncate text-xs font-bold text-slate-500">{{ row.customer_name || 'No customer' }}</p>
                </div>
                <button type="button" class="ops-icon-button" (click)="openWorkOrder(row)" title="Open work order">
                  <i class="fa-solid fa-arrow-up-right-from-square"></i>
                </button>
              </div>
              <div class="mt-3 flex flex-wrap gap-2">
                <span class="inline-flex max-w-full items-center rounded-full px-2.5 py-1 text-xs font-black ring-1" [ngClass]="statusTone(row.lading_status)">
                  <span class="truncate">{{ row.lading_status || row.latest_status || 'Unknown' }}</span>
                </span>
                <span class="ops-chip bg-slate-50 text-slate-700 ring-slate-200">{{ timeAgo(row.status_activity_at) }}</span>
              </div>
              <dl class="mt-4 grid grid-cols-2 gap-3 text-xs">
                <div>
                  <dt class="font-black uppercase tracking-[0.12em] text-slate-400">Appointment</dt>
                  <dd class="m-0 mt-1 font-bold text-slate-700">{{ formatDateTime(row.appointment_end_local || row.appointment_end || row.appointment_date) }}</dd>
                </div>
                <div>
                  <dt class="font-black uppercase tracking-[0.12em] text-slate-400">Carrier</dt>
                  <dd class="m-0 mt-1 truncate font-bold text-slate-700">{{ row.carrier_name || 'No carrier' }}</dd>
                </div>
                <div class="col-span-2">
                  <dt class="font-black uppercase tracking-[0.12em] text-slate-400">Route</dt>
                  <dd class="m-0 mt-1 font-bold text-slate-700">{{ rowRoute(row) }}</dd>
                </div>
              </dl>
            </article>
          </div>

          <div *ngIf="!activeRows.length && !loading" class="flex flex-1 items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-slate-50/70 px-4 py-10 text-center text-sm font-bold text-slate-500">
            No orders in this queue for the current filters.
          </div>
        </div>
      </section>

      <section class="ops-panel rounded-2xl p-4 lg:p-5">
        <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h2 class="m-0 text-lg font-black text-slate-950">Operational Leaders</h2>
            <p class="m-0 mt-1 text-xs font-semibold text-slate-500">Top dimensions by current dashboard scope</p>
          </div>
          <div class="flex flex-wrap gap-2">
            <button
              type="button"
              *ngFor="let tab of dimensionTabs"
              class="ops-tab"
              [class.is-active]="activeDimension === tab.key"
              (click)="selectDimension(tab.key)"
            >
              <span>{{ tab.label }}</span>
            </button>
          </div>
        </div>

        <div class="mt-5 grid gap-3 md:grid-cols-2 xl:grid-cols-5">
          <button
            type="button"
            *ngFor="let row of activeDimensionRows; trackBy: trackByDimension"
            class="ops-leader text-left"
            (click)="applyDimensionFilter(row)"
            [disabled]="!row.uuid"
          >
            <div class="flex items-start justify-between gap-3">
              <div class="min-w-0">
                <p class="m-0 truncate text-sm font-black text-slate-950">{{ row.name }}</p>
                <p class="m-0 mt-1 text-xs font-bold text-slate-500">{{ row.active_count | number }} active</p>
              </div>
              <span class="rounded-full bg-slate-100 px-2 py-1 text-xs font-black text-slate-600">{{ row.count | number }}</span>
            </div>
            <div class="mt-4 h-2 overflow-hidden rounded-full bg-slate-100">
              <div class="h-full rounded-full bg-[#0f766e]" [style.width.%]="percentOf(row.count, maxDimensionCount)"></div>
            </div>
            <div class="mt-3 grid grid-cols-3 gap-2 text-center text-[11px] font-black">
              <span class="rounded-lg bg-rose-50 px-2 py-1 text-rose-700">{{ row.late_appointments | number }} late</span>
              <span class="rounded-lg bg-amber-50 px-2 py-1 text-amber-800">{{ row.due_today | number }} due</span>
              <span class="rounded-lg bg-emerald-50 px-2 py-1 text-emerald-700">{{ row.delivered_today | number }} done</span>
            </div>
          </button>
        </div>

        <div *ngIf="!activeDimensionRows.length && !loading" class="mt-5 rounded-xl border border-dashed border-slate-300 px-4 py-8 text-center text-sm font-bold text-slate-500">
          No dimension leaders for these filters.
        </div>
      </section>
    </div>
  </div>
</app-menu>
